module.exports = __webpack_public_path__ + "img/banner.33d65fdc.png";